import * as iamAccountsDataSource from '@/datasources/iamAccounts.datasource';
import { IamAccount, i18nException, InvalidSchemaException, InvalidTokenException } from '@/models';
import I18N_RESOURCE from '@/i18n/template';

/**
 * Get the IAM account of the user
 * @param accountId The account ID
 * @param accessToken The access token for authentication
 */
export const getAccount = async (accountId: string, accessToken: string): Promise<IamAccount> => {
  try {
    return await iamAccountsDataSource.getAccount(accountId, accessToken);
  } catch (error) {
    throw handleError(error);
  }
};

/**
 * Handles the error from the datasource.
 * @param {any} error Error from the datasource.
 */
const handleError = (error: any) => {
  if (error instanceof InvalidTokenException) {
    return new i18nException(
      'EXCEPTIONS.INVALID_ACCESS_TOKEN',
      I18N_RESOURCE.EXCEPTIONS.INVALID_ACCESS_TOKEN,
      'error',
      'InvalidTokenException',
    );
  }
  if (error instanceof InvalidSchemaException) {
    return new i18nException(
      'EXCEPTIONS.IAM_ACCOUNT.INVALID_SCHEMA',
      I18N_RESOURCE.EXCEPTIONS.IAM_ACCOUNT.INVALID_SCHEMA,
      'info',
      'InvalidSchemaException',
    );
  }
  return new i18nException(
    'EXCEPTIONS.IAM_ACCOUNT.UNKNOWN',
    I18N_RESOURCE.EXCEPTIONS.IAM_ACCOUNT.UNKNOWN,
    'error',
    'UnknownException',
  );
};
